import { jsxs as t, jsx as n } from "react/jsx-runtime";
import e from "./index.es2427.js";
import { useTheme as p } from "./index.es190.js";
import { Icon as v } from "./index.es157.js";
import { BodyText as h } from "./index.es505.js";
const x = ({
  testId: o,
  impactDirection: r,
  barWidth: l,
  impactValue: m
}) => {
  const {
    activeTheme: { theme: s }
  } = p(), i = r === "positive" ? "ArrowUpRight" : "ArrowDownRight", a = r === "positive" ? "success" : "error", d = r === "positive" ? "+" : "-", c = r === "positive" ? s.icon.status.success : s.icon.status.error;
  return /* @__PURE__ */ t(
    "div",
    {
      className: e.miniImpactBarWrapper,
      "data-testid": o,
      "data-icon-type": i,
      "data-icon-color": a,
      "data-bar-color": c,
      children: [
        /* @__PURE__ */ t("div", { className: e.value, children: [
          /* @__PURE__ */ n(
            v,
            {
              type: i,
              color: a,
              size: 16,
              weight: "outline",
              testId: `${o}-icon`
            }
          ),
          /* @__PURE__ */ t(h, { variant: "semi-bold", testId: `${o}-value`, children: [
            d,
            m
          ] })
        ] }),
        /* @__PURE__ */ n(
          "div",
          {
            className: e.bar,
            style: { width: l, background: c },
            "data-testid": `${o}-bar`
          }
        )
      ]
    }
  );
};
export {
  x as MiniImpactBar
};
//# sourceMappingURL=index.es153.js.map
